const env = process.env

const fallbackApi = (name) => `/__api_no_configurada__/${name}`

export const API_USERS_URL = env.REACT_APP_API_USERS_URL || fallbackApi('usuarios')

export const API_PATIENTS_URL = env.REACT_APP_API_PATIENTS_URL || fallbackApi('pacientes')

export const API_PSYCHOLOGISTS_URL =
  env.REACT_APP_API_PSYCHOLOGISTS_URL || fallbackApi('psicologos')

export const API_SESSIONS_URL = env.REACT_APP_API_SESSIONS_URL || fallbackApi('sesiones')

export const API_CONFIG_URL = env.REACT_APP_API_CONFIG_URL || fallbackApi('configuracion')

export const API_AUDIT_URL = env.REACT_APP_API_AUDIT_URL || fallbackApi('auditoria')

export const API_SCHEDULES_URL = env.REACT_APP_API_SCHEDULES_URL || fallbackApi('horarios')

export const API_PAYMENTS_URL = env.REACT_APP_API_PAYMENTS_URL || fallbackApi('pagos')

export const API_REPROGRAMMINGS_URL =
  env.REACT_APP_API_REPROGRAMMINGS_URL || fallbackApi('reprogramaciones')

export const API_ASSIGNMENTS_URL = env.REACT_APP_API_ASSIGNMENTS_URL || fallbackApi('asignaciones')

export const API_BOLD_PAYMENTS_URL =
  env.REACT_APP_API_BOLD_PAYMENTS_URL || fallbackApi('bold-pagos')

export const API_BILLING_URL = env.REACT_APP_API_BILLING_URL || fallbackApi('facturacion')

export const API_CLINICAL_HISTORY_URL =
  env.REACT_APP_API_CLINICAL_HISTORY_URL || fallbackApi('historias-clinicas')

export const API_CLINICAL_HISTORY_CHANGES_URL =
  env.REACT_APP_API_CLINICAL_HISTORY_CHANGES_URL || fallbackApi('cambios-historia-clinica')

export const API_B2B_URL = env.REACT_APP_API_B2B_URL || fallbackApi('b2b')

export const API_MARCA_PERSONAL_URL =
  env.REACT_APP_API_MARCA_PERSONAL_URL || env.REACT_APP_API_B2B_URL || fallbackApi('marca-personal')

export const API_LIQUIDATIONS_URL =
  env.REACT_APP_API_LIQUIDATIONS_URL || fallbackApi('liquidaciones')

export const API_SESSIONS_BY_PSYCHOLOGIST_URL =
  env.REACT_APP_API_SESSIONS_BY_PSYCHOLOGIST_URL || fallbackApi('sesiones-psicologo')
